<template lang="pug">
  .tiles(
        v-if="contents && contents.length" 
        :class="[spacingTop, spacingBottom]"
    )
    .container.mx-auto(ref="container")
      .overview
          Tile(
            v-for="(box, index) in contents"
            ref="container"
            :tile="box"
          )

</template>

<script>
import { get, cloneDeep } from '@/helpers';

import Tile from './Tile';

export default {
    name: 'Tiles',
    data() {
        return {
            config: {
                containerWidth: undefined,
            }
        };
    },
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    components: {
        Tile
    },
    computed: {
        settings() {
            return get(this.section, 'settings') || [];
        },
        contents() {
            let contents = this.section.contents || [];
            return cloneDeep(contents).sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0));
        },
        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },
        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        }
    },
    methods: {

    },
    mounted() {

    }
};
</script>

<style lang="sass" scoped>
@import '~@/assets/sass/variables'

.tiles
    .overview
        @apply grid grid-cols-2 gap-4
        @screen sm
            @apply grid-cols-3
        @screen lg
            @apply grid-cols-4
    .preview-image
      @apply flex justify-center items-center content-center p-4
      background: #fff
      height: 200px
      border: 1px solid #e5e5e5

</style>
